module.exports = __webpack_public_path__ + "static/media/01_tn.842f9b0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/01_tn.jpg
// module id = 310
// module chunks = 0